/**
 * M.3 — Zip export target.
 *
 * Wraps the existing `exportToZip` + `downloadZip` (F7 / H.3) in the
 * ExportTarget shape. Universal — always visible + enabled.
 */

import { downloadZip, exportToZip } from '../toZip';
import type { ExportTarget } from './types';

export const zipTarget: ExportTarget = {
  id: 'zip',
  label: 'Zip (download)',
  isVisible: () => true,
  isEnabled: () => true,
  run: async (site) => {
    const result = await exportToZip(site);
    downloadZip(result);
    return {
      summary: `ZIP export ready: ${result.filename} (${result.filesWritten} notes / flows).`,
    };
  },
};
